import { InjectionToken } from '@angular/core';
import { CmsDataUrl } from '@common/util-models';

export const CMS_DATA_URL = new InjectionToken<CmsDataUrl>('CMS Data Urls');
